import * as Constants from './constants'

const initialState = {
  type: Constants.KHACHHANG_NHOM_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  formData: {},
}

const reducer = function khachHangNhomReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.KHACHHANG_NHOM_DETAIL_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case Constants.KHACHHANG_NHOM_DETAIL_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_NHOM_DETAIL_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case Constants.KHACHHANG_NHOM_UPDATE_REQUESTING:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: true,
        successful: false,
        messages: [],
        errors: [],
      }

    case Constants.KHACHHANG_NHOM_UPDATE_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: true,
        messages: [{
          body: action.payload.message,
          time: new Date(),
        }]
      }

    case Constants.KHACHHANG_NHOM_UPDATE_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        requesting: false,
        successful: false,
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }

    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/KhachHangNhom/reducer.js